import { render, staticRenderFns } from "./all_settings.vue?vue&type=template&id=75b90df8&scoped=true"
var script = {}
import style0 from "./all_settings.vue?vue&type=style&index=0&id=75b90df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b90df8",
  null
  
)

export default component.exports